import * as React from "react";
import { cn } from "../../utils/cn.ts";
import { Input } from "../../components/ui/input.tsx";

export interface InputWithSuffixProps extends React.ComponentProps<"input"> {
  suffix: React.ReactNode;
  suffixClasses?: string; // 允许自定义后缀的样式
  wrapperClasses?: string; // 允许自定义容器的样式
}

const InputWithSuffix = React.forwardRef<
  HTMLInputElement,
  InputWithSuffixProps
>(({ className, suffix, suffixClasses, wrapperClasses, ...props }, ref) => {
  return (
    <div className={cn("relative flex items-center", wrapperClasses)}>
      <Input
        className={cn("flex-1 py-0", className)} // input 默认占满
        ref={ref}
        {...props}
      />
      <div
        className={cn(
          "flex h-full items-center justify-center px-3 pl-1 relative -top-[1px]",
          "pointer-events-none", // 关键：点击穿透
          suffixClasses
        )}
      >
        <span className="text-sm text-muted-foreground">{suffix}</span>
      </div>
    </div>
  );
});
InputWithSuffix.displayName = "InputWithSuffix";

export { InputWithSuffix };
